/* Creme Castle — trusted IST clock for the slot engine (Step 2, Sept 2026).
 *
 * Problem it solves: the theme used to read the hour from Liquid, which is frozen
 * into cached pages, and from the visitor's device clock, which can be in any
 * timezone or simply wrong. This helper asks the server once for the real time
 * (the Date header on a tiny uncached /cart.js request), remembers the offset to
 * the device clock, and hands the engine an IST "now" on every call.
 *
 * QA override: add ?cc_now=2026-09-05T18:30 to the URL (or set
 * localStorage.cc_now) to pin the clock to an IST wall-clock time. Only honoured
 * on a theme preview, never on the live theme.
 */
(function () {
  "use strict";
  var E = window.CCSlotEngine;
  if (!E) return;

  var offsetMs = 0;          // serverNow - Date.now()
  var synced = false;
  var syncing = null;
  // Shopify strips ?preview_theme_id= after setting its cookie, so the URL alone is not
  // enough: Shopify.theme.role is "main" only on the published theme. Evaluated lazily
  // because this file loads in <head> before content_for_header defines window.Shopify.
  function isPreview() {
    var S = window.Shopify;
    return !!(S && S.designMode) ||
      !!(S && S.theme && S.theme.role && S.theme.role !== "main") ||
      /preview_theme_id=|_ab=|preview_key=/.test(location.search) || /\.myshopify\.com$/.test(location.hostname) || location.hostname.indexOf("shopifypreview.com") !== -1;
  }

  // Capture ?cc_now= at load: Dawn rewrites the URL to ?variant=… on the first
  // option click, which would otherwise drop the override before it is read.
  var urlOverride = (function () { var m = location.search.match(/[?&]cc_now=([^&]+)/); return m ? decodeURIComponent(m[1]) : ""; })();
  function override() {
    if (!isPreview()) return "";
    var v = urlOverride;
    try { if (!v) v = localStorage.getItem("cc_now") || ""; else localStorage.setItem("cc_now", v); } catch (e) {}
    return v;
  }

  // Resolve with the corrected epoch. Falls back to the device clock, then to
  // the page-render time if the device clock is absurdly off (> 1 day).
  function sync() {
    if (synced) return Promise.resolve(Date.now() + offsetMs);
    if (syncing) return syncing;
    syncing = fetch("/cart.js?cc_ts=" + Date.now(), { cache: "no-store", credentials: "same-origin" })
      .then(function (r) {
        var d = r.headers.get("date");
        var server = d ? Date.parse(d) : NaN;
        if (!isNaN(server)) offsetMs = server - Date.now();
        synced = true;
        return Date.now() + offsetMs;
      })
      .catch(function () {
        var rendered = (window.ccSlotData && window.ccSlotData.renderedAt) || 0;
        if (rendered && Math.abs(Date.now() - rendered) > 86400000) offsetMs = rendered - Date.now();
        synced = true;
        return Date.now() + offsetMs;
      });
    return syncing;
  }

  function now() {
    return E.nowFrom(Date.now() + offsetMs, override());
  }

  window.ccClock = { sync: sync, now: now, get isPreview() { return isPreview(); }, get offsetMs() { return offsetMs; } };
})();